import ClientModal from './ClientModal.view';

export default ClientModal;
